import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import beneficiaryWorkflowRunsFetched, {
	type BeneficiaryWorkflowRunsFetchedAction,
	type WorkflowRunSummaryPayload,
} from '@Application/WorkflowRuns/BeneficiaryWorkflowRuns/Actions/beneficiaryWorkflowRunsFetched';
import beneficiaryWorkflowRunsFetchFailed, {
	type BeneficiaryWorkflowRunsFetchFailedAction,
} from '@Application/WorkflowRuns/BeneficiaryWorkflowRuns/Actions/beneficiaryWorkflowRunsFetchFailed';
import type FetchBeneficiaryWorkflowRuns from '@Application/WorkflowRuns/BeneficiaryWorkflowRuns/Queries/FetchBeneficiaryWorkflowRuns';
import { getPaginated } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = BeneficiaryWorkflowRunsFetchedAction | BeneficiaryWorkflowRunsFetchFailedAction;

// `getPaginated` requires a mutable `results` array (it pushes subsequent pages into it); the
// dispatched action still carries the `readonly` form declared by the payload type.
type PaginatedBeneficiaryWorkflowRuns = {
	totalRecords: number;
	results: WorkflowRunSummaryPayload[];
};

export default (query: FetchBeneficiaryWorkflowRuns) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// Page indexing starts at 0 server-side; `rowsPerPage: 200` is the server's maximum accepted
			// `rows` value.
			const payload = await getPaginated<PaginatedBeneficiaryWorkflowRuns>(
				`${buildSubjectApiPath(query.facilityId, query.subject)}/workflow-runs?${query.toQueryString()}`,
				{ page: 0, rowsPerPage: 200 },
			);

			const action = beneficiaryWorkflowRunsFetched(
				payload,
				query.facilityId,
				query.subject.subjectId,
				query.subject.typeKey,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = beneficiaryWorkflowRunsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
